import { IDARI_MAHALLE_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const IdariMahalleSorgula = () => {
    return getRequest({url:IDARI_MAHALLE_SORGULA});
}

export default IdariMahalleSorgula;